import {getOIDCUrl} from 'utils/envUtils'
import {INTERACTION_UID} from 'const'
import {getClient} from 'utils/stringUtils'

class SessionService {
  static clearInteraction = () => {
    const interactionUid = localStorage.getItem(INTERACTION_UID)
    if (interactionUid) {
      localStorage.removeItem(INTERACTION_UID)
    }
  }

  static logoutWithRedirect = redirectUrl => {
    const clientId = getClient(window.location.search)

    try {
      if (clientId && redirectUrl) {
        this.clearInteraction()
        const query = `client_id=${clientId}&returnTo=${encodeURIComponent(redirectUrl)}`
        window.location.assign(`${getOIDCUrl()}/logout?${query}`)
      }
    } catch {
      throw new Error('Logout Session Error')
    }
  }
}

export default SessionService
